import React from 'react'
import { getHeadshot } from './../../../../shared/utilities/getHeadshot.function'
import placeholder_picture from './../../../../assets/images/user_placeholder.png'

// Strip HTML tags / entities from s_about and clamp to a short card snippet.
const toSnippet = (html, max = 120) => {
  if (!html) return ''
  const text = `${html}`
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/\s+/g, ' ')
    .trim()
  if (!text) return ''
  return text.length > max ? text.slice(0, max).trim() + '…' : text
}

// u_spoken_language may be a JSON array, a comma/pipe list, or a single value.
const parseLanguages = raw => {
  if (!raw) return []
  let value = raw
  if (typeof raw === 'string') {
    const trimmed = raw.trim()
    if (!trimmed) return []
    try {
      value = JSON.parse(trimmed)
    } catch (e) {
      value = trimmed.split(/[,|]/)
    }
  }
  if (!Array.isArray(value)) value = [value]
  return value
    .map(l => `${l}`.trim())
    .filter(Boolean)
    .slice(0, 4)
}

const AgentCard = ({ agent }) => {
  if (!agent || !agent.u_login) return null

  const name = `${(agent.u_nickname ? agent.u_nickname : agent.u_fname) || ''} ${agent.u_lname || ''}`.trim()
  const location =
    agent.u_city && agent.u_state ? `${agent.u_city}, ${agent.u_state}` : agent.u_state || agent.s_fulladdress || ''
  const snippet = toSnippet(agent.s_about)
  const languages = parseLanguages(agent.u_spoken_language)
  const headshot = getHeadshot({ id: agent.id, u_picture: agent.u_picture })

  return (
    <a className='agent-card' href={`/${agent.u_login}`} aria-label={`View profile for ${name || 'this agent'}`}>
      <div className='agent-card__photo'>
        <img
          src={headshot}
          alt={name ? `Headshot of ${name}` : 'Agent headshot'}
          onError={e => {
            if (e.target.src !== placeholder_picture) e.target.src = placeholder_picture
          }}
        />
      </div>
      <div className='agent-card__body'>
        {name ? <h3 className='agent-card__name'>{name}</h3> : null}
        {location ? (
          <p className='agent-card__location'>
            <span className='icon-location-pin' aria-hidden='true'></span>
            {location}
          </p>
        ) : null}
        {snippet ? <p className='agent-card__bio'>{snippet}</p> : null}
        {languages.length ? (
          <div className='agent-card__languages-group'>
            <span className='agent-card__languages-label'>{`Spoken Language${languages.length > 1 ? 's' : ''}`}</span>
            <ul className='agent-card__languages' aria-label='Languages spoken'>
              {languages.map(lang => (
                <li key={lang} className='agent-card__language'>
                  {lang}
                </li>
              ))}
            </ul>
          </div>
        ) : null}
        <span className='agent-card__cta'>View Profile</span>
      </div>
    </a>
  )
}

export default AgentCard
